import z, { ZodType } from "zod";

import { looseUuid } from "@thalamos/common";

/**
 * An Email Address
 */
export type EmailUnbranded = string;
export const EmailSchema = z
  .email()
  .brand<"vision-common:Email">() satisfies ZodType<EmailUnbranded>;
export type Email = z.infer<typeof EmailSchema>;

/**
 * An Id to reference an Email
 */
export type EmailIdUnbranded = string;
export const EmailIdSchema = looseUuid().brand<"vision-common:EmailId">();
export type EmailId = z.infer<typeof EmailIdSchema>;
